import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../auth";

/** Mode "forcé" si user.must_change_password === 1 (pas de mot de passe actuel demandé). */
export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const forced = user?.must_change_password === 1;
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (next.length < 8) {
      setErr("8 caractères minimum.");
      return;
    }
    if (next !== confirm) {
      setErr("Les deux saisies diffèrent.");
      return;
    }
    setBusy(true);
    try {
      await api("/me/password", {
        method: "POST",
        json: { current: forced ? undefined : current, next },
      });
      setOk(true);
      await refresh();
      setTimeout(() => nav("/", { replace: true }), 800);
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Erreur");
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <h2>{forced ? "Choisir un nouveau mot de passe" : "Changer mon mot de passe"}</h2>
      {forced && (
        <p className="muted">
          Votre mot de passe actuel a été défini par l'administrateur.
          Veuillez en choisir un personnel pour continuer.
        </p>
      )}
      <form onSubmit={submit}>
        {!forced && (
          <>
            <label className="section-h">Mot de passe actuel</label>
            <input
              type="password"
              autoComplete="current-password"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              required
            />
          </>
        )}

        <label className="section-h" style={{ marginTop: 14, display: "block" }}>
          Nouveau mot de passe
        </label>
        <input
          type="password"
          autoComplete="new-password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          required
          minLength={8}
        />

        <label className="section-h" style={{ marginTop: 14, display: "block" }}>
          Confirmer
        </label>
        <input
          type="password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          required
          minLength={8}
        />

        {err && <div className="error" style={{ marginTop: 10 }}>{err}</div>}
        {ok && <div className="muted" style={{ marginTop: 10, color: "var(--st-validated)" }}>Mot de passe modifié.</div>}

        <div style={{ height: 18 }} />
        <button className="btn btn-primary full" type="submit" disabled={busy}>
          {busy ? "Enregistrement…" : "Valider"}
        </button>
      </form>
    </>
  );
}
